<template>
  <div
    :style="{
      padding: '24px',
      margin: '24px 16px 24px 16px',
      background: '#fff',
      minHeight: '100px',
    }"
  >

    <a-row>
      <a-col :span="11">
        <a-form-model-item label="货币通用">
          <a-switch
            v-model="currencyRecord"
            @change="onChange"
            checked-children="开启"
            un-checked-children="关闭"
          />
          <!--          <a-switch default-checked :checked="currencyRecord" @change="onChange111"/>-->
          <span class="tipspan">tips:开启后各个门店游戏币/彩票统一通用</span>
        </a-form-model-item>
      </a-col>
    </a-row>
    <a-row>
      <a-col :span="11">
        <a-form-model-item label="积分通用">
          <a-switch v-model="integralRecord"
                    @change="onChanges"
                    checked-children="开启"
                    un-checked-children="关闭"
          />
          <span class="tipspan">tips:开启后各个门积分一通用</span>
        </a-form-model-item>
      </a-col>
    </a-row>
  </div>
</template>

<script>
  import {currency, currencyEdit, configGetCurrencyAndIntegral, configEditCurrencyAndIntegral} from "@/api/homeApi.js";
  import {message} from "ant-design-vue";

  export default {
    data() {
      return {
        currencyRecord: null,
        integralRecord: null,
      };
    },
    created() {
      // this.getCurrency();
      this.configGetCurrencyAndIntegral();
    },
    methods: {
      onChange() {
        configEditCurrencyAndIntegral({currencyConfig:this.currencyRecord}).then(res =>{
          this.configGetCurrencyAndIntegral();
          message.success(res.info);
        });
        // console.log(this.currencyRecord);
        // if (checked === true) {
        //   currencyEdit("1", 8001).then((res) => {
        //     this.getCurrency();
        //     message.success(res.data);
        //   });
        // } else {
        //   currencyEdit("0", 8001).then((res) => {
        //     this.getCurrency();
        //     message.success(res.data);
        //   });
        // }
      },
      onChanges() {
        configEditCurrencyAndIntegral({integralConfig:this.integralRecord}).then(res =>{
          this.configGetCurrencyAndIntegral();
          message.success(res.info);
        });
        // if (checked === true) {
        //   currencyEdit("1", 8003).then((res) => {
        //     this.getCurrency();
        //     message.success(res.data);
        //   });
        // } else {
        //   currencyEdit("0", 8003).then((res) => {
        //     this.getCurrency();
        //     message.success(res.data);
        //   });
        // }
      },
      getCurrency() {
        currency().then((res) => {
          this.currencyRecord = res.data.currencyRecord;
          this.integralRecord = res.data.integralRecord;
        });
      },
      configGetCurrencyAndIntegral() {
        configGetCurrencyAndIntegral().then(res => {
          if (res.data.currencyConfig != null) {
            this.currencyRecord = res.data.currencyConfig;
          }else {
            this.currencyRecord = false;
          }
          if (res.data.integralConfig != null) {
            this.integralRecord = res.data.integralConfig;
          }else {
            this.integralRecord = false;
          }
        });
      },
    },
  };
</script>

<style>
  .tipspan {
    color: red;
    margin-left: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/views/financialManagement/generalSettings/generalSettings.vue